import { useState } from "react";
import { CalendarDays } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Calendar } from "./ui/calendar";

export default function CalendarJump({ onJump }) {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState();

  const handleSelect = (date) => {
    if (!date) return;
    setSelected(date);
    setOpen(false);
    // Jump to end of selected day so we include all blocks from that date
    const end = new Date(date);
    end.setHours(23, 59, 59, 999);
    onJump?.(end.toISOString(), date);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          className="p-2 rounded-md hover:bg-secondary transition-colors"
          aria-label="jump to date"
          data-testid="calendar-jump-button"
        >
          <CalendarDays className="w-4 h-4" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="end"
        className="w-auto p-0 font-sans"
        data-testid="calendar-jump-popover"
      >
        <Calendar
          mode="single"
          selected={selected}
          onSelect={handleSelect}
          disabled={(d) => d > new Date()}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
